import { T } from './helpers';

// I NOMI COMMERCIALI DEGLI EDITOR, scritti una volta. Il nome che l'utente legge cambia con il
// marketing — il Composer oggi si chiama «Product Logic» — mentre nel codice resta quello di sempre:
// rinominarlo qui lo cambia in header, messaggi, liste e pulsanti senza cercarlo pagina per pagina.
// Le frasi che lo contengono lo ricevono come `{0}` via `stringFormat`.
export const productLogicName = () => T._('Product Logic', 'Admin');
